export default __webpack_public_path__ + "static/media/mutate-alex-6.3f40bd94.png";